import { render, staticRenderFns } from "./MasterClass.vue?vue&type=template&id=7abd5c21"
import script from "./MasterClass.vue?vue&type=script&lang=js"
export * from "./MasterClass.vue?vue&type=script&lang=js"
import style0 from "./MasterClass.vue?vue&type=style&index=0&id=7abd5c21&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports